var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[(_vm.subscription)?_c('AgencySubscriptionForm',{attrs:{"form-data":_vm.subscription},on:{"close":_vm.goBack,"created":_vm.onSaved}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }